import React, { useState, useMemo, Fragment } from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Collapse from '@material-ui/core/Collapse';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import ProfessionalCategories from 'app/utils/ProfessionalCategories';

const filter = createFilterOptions();

export default function IndustryTextField(props) {

    const { value, onChange, groupBy, width, label, error, helperText } = props

    const [ openCategories, setOpenCategories ] = useState([0]);
    const [ filtering, setFiltering ] = useState(false);

    const handleOpenCategories = key => {
        const i = openCategories.indexOf(key);
        const newOpenCategories = [...openCategories];

        if (i > -1) {
            newOpenCategories.splice(i,1);
        } else {
            newOpenCategories.push(key)
        }

        setOpenCategories(newOpenCategories);
    }

    const options = ProfessionalCategories.sort((a, b) => {
        if (a[groupBy] == "Most Popular") return -1;
        if (b[groupBy] == "Most Popular") return 1;

        if ( a[groupBy] < b[groupBy] ){
            return -1;
        }
        if ( a[groupBy] > b[groupBy] ){
            return 1;
        }

        return 0;
    });

    return (
        <Autocomplete
            id="input-professional-category-select"
            options={options}
            filterOptions={(options, params) => {
                (params.inputValue == "") ? setFiltering(false) : setFiltering(true);
                return filter(options, params);
            }}
            renderGroup={(params) => (
                <Fragment key={params.key} >
                    <ListItem dense button onClick={() => handleOpenCategories(params.key)}>
                        <ListItemText primary={params.group} />
                            <ListItemSecondaryAction>
                                {(openCategories.indexOf(params.key) > -1 || filtering) ? (
                                    <ExpandLess size="small" />
                                ) : (
                                    <ExpandMore size="small" />
                                )}
                            </ListItemSecondaryAction>
                    </ListItem>
                    <Collapse in={(openCategories.indexOf(params.key) > -1 || filtering)}>
                        {params.children}
                    </Collapse>
                </Fragment>
            )}
            renderOption={(option) => (
                <ListItemText inset secondary={option.name} />
            )}
            value={(value && value != "") ? ProfessionalCategories.find(pc => pc.value == value) : null}
            groupBy={group => group[groupBy]}
            getOptionLabel={(option) => option.name}
            style={{ width: width || 'auto' }}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label || "Industry"}
                    variant="outlined"
                    error={error}
                    helperText={helperText}
                />
            )}
            onChange={onChange}
            openOnFocus
        />
    )
}
